import { Box, Button, Divider, FormControl, Grid, IconButton, InputLabel, MenuItem, MenuList, Modal, Pagination, Popover, Select, Table, TableBody, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useEffect, useState, useCallback } from "react";
import { Search, SearchIconWrapper, style, StyledInputBase, StyledTableCell, StyledTableRow } from "../../../styles/styles";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { BsSearch } from "react-icons/bs";
import { toast } from "react-toastify";
import api from "../../../services/QualityAssurance";
import { useSelector } from "react-redux";
import TableLoader from "../../TableLoader";
import EditBook from "./EditBook";
import { useParams } from "react-router-dom";
import { formatCurrency } from "../../../services/utils";

export const BookTable = ({ refreshKey, onRefresh }) => {
    const { admToken } = useSelector((state) => state.auth);
    const { id } = useParams();
    const [anchorEl, setAnchorEl] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [selectedItemId, setSelectedItemId] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [selected, setSelected] = useState([]);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [deleting, setDeleting] = useState(false);

    const [pagination, setPagination] = useState({
        pageNumber: 1,
        pageSize: 10,
        totalRecords: 0,
        totalPages: 0
    });

    const handleOpenModal = () => setOpenModal(true);
    const handleCloseModal = () => setOpenModal(false)
    const handleCloseDeleteModal = () => setOpenDeleteModal(false);
    const handleOpenDeleteModal = () => setOpenDeleteModal(true);

    const handleClick = (event, item) => {
        setAnchorEl(event.currentTarget);
        setSelectedItem(item);
        setSelectedItemId(item.id);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleEdit = () => {
        handleClose();
        handleOpenModal();
    };

    const fetchData = useCallback(async () => {
        if (!id) return;
        try {
            setLoading(true);
            const search = searchText?.trim() || "";
            const res = await api.getBook(admToken, searchText ? searchText : null, Number(id));
            if (res.status && res.statusCode === 2) {
                setData(res.data)
                setPagination(prev => ({
                    ...prev,
                    totalRecords: res.totalRecord,
                    totalPages: Math.ceil(res.totalRecord / pagination.pageSize),
                    currentPage: res.currentPage || 1
                }));
                setSelected([]);
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            setLoading(false);
        }
    }, [admToken, searchText, pagination.pageSize, pagination.pageNumber, id]);

    useEffect(() => {
        fetchData();
    }, [admToken, searchText, pagination.pageSize, pagination.pageNumber, id, refreshKey, onRefresh]);

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
        setPagination(prev => ({ ...prev, pageNumber: 1 }));
    };

    const handlePageChange = (event, newPage) => {
        setPagination(prev => ({ ...prev, pageNumber: newPage }));
    };

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        fetchData();
    };

    const handleDelete = useCallback(async () => {
        setDeleting(true)
        try {
            if (!selectedItemId) return;
            const res = await api.deleteBook(admToken, selectedItemId);
            if (res.status && res.statusCode === 2) {
                toast.success(res.data.message || res.message);
                fetchData();
                handleCloseDeleteModal();
                handleClose();
            } else {
                toast.error(res.data.message || res.message);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setDeleting(!deleting)
        }
    }, [admToken, selectedItemId, fetchData]);

    const open = Boolean(anchorEl);
    const popoverId = open ? "simple-popover" : undefined;

    return (
        <Box>
            <Box>
                <Box
                    sx={{
                        pt: 4,
                        background: "rgba(103, 30, 120, 0.1)",
                        height: "100px",
                        pl: { xs: 2.5 },
                        overflow: "hidden"
                    }}
                    onSubmit={handleSearchSubmit}
                >
                    <Search
                        sx={{
                            width: {
                                lg: "345px",
                                md: "330px",
                                sm: "auto",
                                xs: "auto",
                                pl: { xs: 6 },
                            },
                        }}
                    >
                        <SearchIconWrapper>
                            <BsSearch />
                        </SearchIconWrapper>
                        <StyledInputBase
                            placeholder="Search…"
                            inputProps={{ "aria-label": "search" }}
                            value={searchText}
                            onChange={handleSearchChange}
                        />
                    </Search>
                </Box>
                <TableContainer>
                    <Table
                        sx={{
                            minWidth: 700,
                            fontFamily: "Gilroy-Regular",
                            borderRadius: "0",
                        }}
                        aria-label="customized table"
                    >
                        <TableHead
                            sx={{ backgroundColor: "rgba(103, 30, 120, 0.1)", width: "100%" }}
                        >
                            <TableRow>
                                <StyledTableCell>S/N</StyledTableCell>
                                <StyledTableCell>Title</StyledTableCell>
                                <StyledTableCell>Author</StyledTableCell>
                                <StyledTableCell>ISBN</StyledTableCell>
                                <StyledTableCell>Subject</StyledTableCell>
                                <StyledTableCell>Class</StyledTableCell>
                                <StyledTableCell>Cost</StyledTableCell>
                                <StyledTableCell>Copies</StyledTableCell>
                                <StyledTableCell></StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ fontFamily: "Gilroy-Regular", width: "100%" }}>
                            {loading ? (
                                <StyledTableRow>
                                    <StyledTableCell colSpan={9} align="center">
                                        <TableLoader />
                                    </StyledTableCell>
                                </StyledTableRow>
                            ) : data?.length > 0 ? (
                                data?.map((row, index) => (
                                    <StyledTableRow key={row.id || index}>
                                        <StyledTableCell component="th" scope="row">{index + 1}</StyledTableCell>
                                        <StyledTableCell>{row.bookTitle}</StyledTableCell>
                                        <StyledTableCell>{row.bookAuthor}</StyledTableCell>
                                        <StyledTableCell>{row.isbn}</StyledTableCell>
                                        <StyledTableCell>{row.subject}</StyledTableCell>
                                        <StyledTableCell>{row.class}</StyledTableCell>
                                        <StyledTableCell>{formatCurrency(row.cost || 0)}</StyledTableCell>
                                        <StyledTableCell>{row.copies}</StyledTableCell>
                                        <StyledTableCell>
                                            <IconButton onClick={(e) => handleClick(e, row)}>
                                                <MoreVertIcon />
                                            </IconButton>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                ))
                            ) : (
                                <StyledTableRow>
                                    <StyledTableCell colSpan={9} align="center">
                                        No activities found
                                    </StyledTableCell>
                                </StyledTableRow>
                            )}
                        </TableBody>
                    </Table>
                    {pagination?.totalPages > 1 && (
                        <Box sx={{ display: "flex", justifyContent: "end", mt: 3, mb: 2 }}>
                            <Pagination
                                count={pagination.totalPages}
                                page={pagination.currentPage}
                                onChange={handlePageChange}
                                color="primary"
                                sx={{
                                    '& .MuiPaginationItem-root': {
                                        color: '#671E78',
                                    },
                                    '& .Mui-selected': {
                                        backgroundColor: 'rgba(103, 30, 120, 0.1)',
                                    },
                                }}
                                showFirstButton
                                showLastButton
                            />
                        </Box>
                    )}
                </TableContainer>
            </Box>
            <Popover
                id={popoverId}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                <Box
                    sx={{
                        bgcolor: "#671E78",
                        color: "#fff",
                        fontFamily: "Gilroy-Regular",
                        px: 3,
                    }}
                >
                    <MenuList sx={{ fontFamily: "Gilroy-Regular" }}>
                        <MenuItem
                            onClick={() => {
                                handleEdit()
                            }}
                        >
                            Edit
                        </MenuItem>
                        <MenuItem
                            onClick={() => {
                                if (selectedItem) {
                                    handleClose();
                                    handleOpenDeleteModal();
                                }
                            }}
                        >
                            Delete
                        </MenuItem>
                    </MenuList>
                </Box>
            </Popover>
            {/* Edit */}
            <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Box align="right" sx={{}}>
                        <IconButton onClick={handleCloseModal}>
                            <HighlightOffIcon />
                        </IconButton>
                    </Box>
                    <Box>
                        <Typography
                            variant="h4"
                            sx={{ textAlign: "center", mb: 2, fontFamily: "Gilroy-Medium" }}
                        >
                            Edit Book
                        </Typography>
                        <Divider />
                        <Box p={3} sx={{ overflowY: "scroll", height: "450px" }}>
                            <EditBook
                                onSuccess={() => {
                                    onRefresh();
                                    handleCloseModal();
                                }}
                                selectedItem={selectedItem}
                            />
                        </Box>
                    </Box>
                </Box>
            </Modal>
            <Modal
                open={openDeleteModal}
                onClose={handleCloseDeleteModal}
                aria-labelledby="delete-confirmation-modal"
            >
                <Box sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    bgcolor: "background.paper",
                    borderRadius: "10px",
                    boxShadow: 24,
                    p: 4,
                }}>
                    <Typography variant="h6" sx={{ fontFamily: "Gilroy-Medium", mb: 2 }}>
                        Confirm Delete
                    </Typography>
                    <Typography variant="body1" sx={{ fontFamily: "Gilroy-Regular", mb: 3 }}>
                        Are you sure you want to delete this Book?
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                        <Button
                            variant="outlined"
                            onClick={handleCloseDeleteModal}
                            sx={{ textTransform: 'initial', fontFamily: "Gilroy-Regular" }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            onClick={handleDelete}
                            sx={{
                                textTransform: 'initial',
                                fontFamily: "Gilroy-Regular",
                                bgcolor: '#671E78',
                                '&:hover': { bgcolor: '#4e165a' }
                            }}
                        >
                            {deleting ? "Deleting.." : "Delete"}
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </Box>
    );
};